import type { TypeInstanceMap, VariableADTvalue } from '@lighthouse/core'
import type { VariableTree2 } from '@lighthouse/shared'
import { VariablePicker } from '@lighthouse/shared'
import { usePopupState } from 'material-ui-popup-state/hooks'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

import { AddVariableButton } from './AddVariableButton'

const SCxContainer = styled.div<{ width?: number }>`
    height: 36px;
    display: flex;
    align-items: center;
    gap: 8px;
`

interface NodeFieldPreviewProps {
    innerTypes: TypeInstanceMap[]
    upstreamOptions: VariableTree2[]
    onSelect?: (value: VariableADTvalue) => void
}

export const NodeFieldVariable: React.FC<NodeFieldPreviewProps> = ({ innerTypes, upstreamOptions, onSelect }) => {
    const popupState = usePopupState({ variant: 'popover', popupId: 'popupState' })
    const editorRef = useRef(null)

    useEffect(() => {
        if (editorRef.current) {
            popupState.setAnchorEl(editorRef.current)
        }
    }, [popupState])

    return (
        <SCxContainer>
            <VariablePicker
                innerTypes={innerTypes}
                upstreamOptions={upstreamOptions}
                triggerWrapper={AddVariableButton}
                onSelect={onSelect}
            />
        </SCxContainer>
    )
}
